import React from "react";
import "./Profile.scss";
import ImageInput from "./ImageInput";
const Edit = ({ profile, setProfile, inputHandler, clickHandler }) => {
  return (
    <div
      class="modal fade profile"
      id="EditModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content ">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              ویرایش اطلاعات
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div className=" card info Imodal">
              <div className="ProfileImage">
                <ImageInput src={profile.profilePic} radiusPercentage={50} />
                {/* <img src={profile.profilePic} alt="profile" className="icon" /> */}
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-6 itemM">
                  <div className="titleM">نام و نام خانوادگی</div>
                  <input
                    type="text"
                    className="desM"
                    value={profile.fullName}
                    name="fullName"
                    onChange={inputHandler}
                  />
                </div>
                <div className="col-md-6 col-lg-6 itemM">
                  <div className="titleM">نام مستعار</div>
                  <input
                    type="text"
                    className="desM"
                    value={profile.name}
                    name="name"
                    onChange={inputHandler}
                  />
                </div>
                <div className="col-md-6 col-lg-6 itemM">
                  <div className="titleM">نام کاربری</div>
                  <input
                    type="text"
                    className="desM"
                    value={profile.id}
                    name="id"
                    onChange={inputHandler}
                  />
                </div>
                <div className="col-md-6 col-lg-6 itemM">
                  <div className="titleM">شماره موبایل</div>
                  <input
                    type="text"
                    className="desM"
                    value={profile.phone}
                    disabled
                    name="phone"
                    onChange={inputHandler}
                  />
                </div>
                <div className="col-md-6 col-lg-6 itemM">
                  <div className="titleM">ایمیل</div>
                  <input
                    type="text"
                    className="desM"
                    value={profile.email}
                    name="email"
                    onChange={inputHandler}
                  />
                </div>
                <div className="col-md-6 col-lg-6 itemM">
                  <div className="titleM">درباره من</div>
                  <textarea
                    rows="5"
                    cols="31"
                    className="desM"
                    value={profile.about}
                    name="about"
                    onChange={inputHandler}
                    style={{ resize: "none" }}
                  >
                    {profile.about}
                  </textarea>
                </div>
                <div className="col-md-6 col-lg-6 itemM">
                  <div className="titleM">وضعیت حساب کاربری شما</div>
                  <div
                    className="button b2"
                    id="button-13"
                    onClick={(e) =>
                      setProfile((profile) => ({
                        ...profile,
                        accountStatus: !profile.accountStatus,
                      }))
                    }
                  >
                    <input
                      type="checkbox"
                      className="checkbox"
                      checked={profile.accountStatus}
                    />
                    <div
                      className={`knobs ${
                        profile.accountStatus == true ? "active" : "inactive"
                      }`}
                    >
                      <span></span>
                    </div>
                    <div className="layer"></div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={clickHandler}
                >
                  ذخیره تغییرات
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Edit;
